import { zodResolver } from '@hookform/resolvers/zod';
import { VariantType } from '@pelicargo/types';
import { useEffect } from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { TrpcInputs } from '../../config/trpc';
import { getDifferences } from '../../utils/findChangedKeys';
import { QuoteVariant } from '../../utils/types';

type QuoteVariantForm = NonNullable<TrpcInputs['updateQuoteVariant']>;
type UseQuoteVariantForm = {
  methods: UseFormReturn<QuoteVariantForm>;
  defaultValues?: Partial<QuoteVariant>;
};
type Options = { isCreate: boolean };

const defaultOptions = { isCreate: false };

const validationSchema = z.object({
  name: z.string({ required_error: 'Required' }),
  type: z.nativeEnum(VariantType),
});

export const useQuoteVariantForm = (
  data?: Partial<QuoteVariant>,
  { isCreate }: Options = defaultOptions,
): UseQuoteVariantForm => {
  const { setValue, getValues, ...methods } = useForm<QuoteVariantForm>({
    mode: 'onBlur',
    resolver: zodResolver(validationSchema),
    defaultValues: data,
  });

  useEffect(() => {
    const updateFields = () => {
      const changes = getDifferences<QuoteVariantForm>(getValues(), data);
      if (!changes.length) return;

      changes.map(([key, value]) => setValue<any>(key, value));
    };

    // Run if we're not on create & we have data
    if (!isCreate && data) updateFields();
  }, [data, getValues, setValue, isCreate]);

  return { defaultValues: data, methods: { ...methods, getValues, setValue } };
};
